exports = module.exports = require("../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3PxSRyT_0AQkzGoJckfOOm{height:44px;-ms-flex-negative:0;flex-shrink:0}html[dir] ._3PxSRyT_0AQkzGoJckfOOm{background-color:\"[theme:neutralLighter, default:#f3f2f1]\";border-bottom:solid 1px \"[theme:neutralLight, default:#edebe9]\"}._21Rl7E752VR2B-DRk5Mo8-{max-width:calc(100vw - 49px)}", ""]);
// Exports
exports.locals = {
	"placeholder": "_3PxSRyT_0AQkzGoJckfOOm",
	"pplHubCommandBar": "_21Rl7E752VR2B-DRk5Mo8-"
};